import React, {useEffect, useState} from 'react'
import Loader from "../../../../Loader/Loader";
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import DashboardMenu from "../../../layout/dashboardMenu";


const PJPView = ({
                     match,
                     pjpDetailsById,
                     PJPDetailsByD = [],
                     history
                 }) => {

    const [isLoading, setIsLoading] = useState(false)


    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await pjpDetailsById(match?.params?.pjp_id)
            setIsLoading(false)
        })()
    }, [])

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Toll Visiting"}
                            history={history}
                        />
                        {/*BODY*/}
                        <div className="container-fluid common-bg">
                            <>
                                <form>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading" style={{backgroundColor:'bisque'}}>
                                                <h1 className="h3 mb-0 text-black-100"><b>Toll Visited</b></h1>
                                            </div>
                                            <div className="card-body bg-white">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        <div className="col-md-6 float-field ">
                                                            <input type="number"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   value={PJPDetailsByD?.data?.account_details?.fast_tag_toll_no}
                                                            />
                                                            <label className="large-label float-lb">
                                                                Plaza Id
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field ">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   value={PJPDetailsByD?.data?.account_details?.client_name}
                                                            />
                                                            <label className="large-label float-lb">
                                                                Plaza Name
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {PJPDetailsByD?.data && PJPDetailsByD?.data?.am_visited_info && Object.keys(PJPDetailsByD?.data?.am_visited_info).length > 0 &&
                                        <>
                                            {PJPDetailsByD?.data?.am_visited_info.map((val, i) => {
                                                return (
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div
                                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading" style={{backgroundColor:'bisque'}}>
                                                                <h1 className="h3 mb-0 text-black-100"><b>Competitor Analysis</b></h1>
                                                            </div>
                                                            <div className="card-body bg-white">
                                                                <div className="user">
                                                                    <div className="form-group row">
                                                                        <div className="col-md-6 float-field " key={i}>
                                                                            <input type="text"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   required={true}
                                                                                   value={val?.name}
                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                Competitor Name
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-md-6 float-field ">
                                                                            <input type="text"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   required={true}
                                                                                   value={val?.bank}
                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                FASTag Bank Name
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-md-6 float-field ">
                                                                            <input type="text"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   value={val?.employee_type}
                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                Employee Type
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-md-6 float-field ">
                                                                            <input type="number"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   required={true}
                                                                                   value={val?.no_of_fse}
                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                Number of FSEs
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-md-6 float-field ">
                                                                            <input type="float"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   required={true}
                                                                                   value={val?.salary}
                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                Monthly Salary
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-md-6 float-field ">
                                                                            <input type="float"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   value={val?.min_tags}
                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                Min. Number of tags sold to be eligible for salary
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-md-6 float-field ">
                                                                            <input type="float"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   value={val?.tag_sold}
                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                Monthly tags sold
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                )
                                            })}

                                        </>
                                    }

                                </form>
                            </>

                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default PJPView